import { Group, Paper, Switch } from '@common/ui'
import TrimmedTextInput from './TrimmedTextInput'
import { com } from '@eidu/web'
import Date = com.eidu.sharedlib.form.definition.Date
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'

type DateItemProps = {
  item: Date
  onChange?: (item: Date) => void
}

const DateItem: React.FC<DateItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <Group gap="md" wrap="nowrap" align="center">
      <TrimmedTextInput
        label="Prompt"
        value={item.prompt}
        onChange={(e) =>
          onChange?.(withKey(item.copy(e.target.value, item.key, item.useCurrentAsDefault, item.required), item))
        }
        style={{ flex: 1 }}
        disabled={!onChange}
      />
      <FormKeyField
        value={item.key}
        onChange={(e) =>
          onChange?.(withKey(item.copy(item.prompt, e.target.value, item.useCurrentAsDefault, item.required), item))
        }
        disabled={!onChange}
      />
      <Switch
        checked={item.useCurrentAsDefault}
        onChange={(e) => onChange?.(withKey(item.copy(item.prompt, item.key, e.target.checked, item.required), item))}
        disabled={!onChange}
        label="Default&nbsp;to&nbsp;current"
      />
      <Switch
        checked={item.required}
        onChange={(e) =>
          onChange?.(withKey(item.copy(item.prompt, item.key, item.useCurrentAsDefault, e.target.checked), item))
        }
        disabled={!onChange}
        label="Required"
      />
    </Group>
  </Paper>
)

export default DateItem
